import { PrivacyPolicyScreen } from '../features/legal/PrivacyPolicyScreen'

export function PrivacyPolicyPage() {
  return <PrivacyPolicyScreen />
}
